var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_edit_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_edit_group2",
    transform: "translate(-697.000000, -261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_edit_group3",
    transform: "translate(681.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_edit_group4",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icons_edit_polygon1",
    points: "0 0 24 0 24 23.5789474 0 23.5789474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,16.9473684 L3,20.6315789 L6.75,20.6315789 L17.81,9.76561404 L14.06,6.08140351 L3,16.9473684 Z M20.71,6.91649123 C21.1,6.53333333 21.1,5.91438596 20.71,5.53122807 L18.37,3.2322807 C17.98,2.84912281 17.35,2.84912281 16.96,3.2322807 L15.13,5.03017544 L18.88,8.71438596 L20.71,6.91649123 Z",
    id: "icons_edit_path1",
    fill: "#768097",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEdit);
export default __webpack_public_path__ + "static/media/icons_edit.8c071622.svg";
export { ForwardRef as ReactComponent };